import React from 'react';
import * as XLSX from 'xlsx';

const PostLaminationView = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const postLamination = inspectionData.PostLamination;

  if (!postLamination) {
    return <p className="text-gray-500">No PostLamination data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Section',
      'Sub-Section',
      'Product/Module Number',
      'Frequency/Remarks',
      'Observation 1/Status',
      'Observation 2',
      'Specifications',
      'Non-Conformance',
    ]);

    // Populate data for each section and sub-section
    Object.entries(postLamination).forEach(([sectionKey, sectionData]) => {
      const sectionName = sectionKey.replace(/_post$/, '').replace(/([A-Z])/g, ' $1').trim();

      Object.entries(sectionData).forEach(([subKey, subData]) => {
        if (subKey === 'nonConformance') {
          worksheetData.push([sectionName, 'Non-Conformance', '', '', '', '', '', subData || 'N/A']);
        } else if (Array.isArray(subData)) {
          const isModuleInspection = subKey === 'ModuleInspection';
          subData.forEach((item) => {
            if (isModuleInspection) {
              worksheetData.push([
                sectionName,
                subKey.replace(/([A-Z])/g, ' $1').trim(),
                item.moduleNumber || 'N/A',
                item.remarks || 'N/A',
                item.status || 'N/A',
                '', // No Observation 2
                '', // No Specifications
                '',
              ]);
            } else {
              worksheetData.push([
                sectionName,
                subKey.replace(/([A-Z])/g, ' $1').trim(),
                item.product || 'N/A',
                item.frequency || 'N/A',
                item.observation1 || 'N/A',
                item.observation2 || 'N/A',
                item.specifications || 'N/A',
                '',
              ]);
            }
          });
        }
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PostLamination');
    XLSX.writeFile(workbook, 'PostLaminationData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Post Lamination Data</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(postLamination).map(([sectionKey, sectionData]) => (
        <div key={sectionKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            {sectionKey.replace(/_post$/, '').replace(/([A-Z])/g, ' $1').trim()}
          </h3>
          {Object.entries(sectionData).map(([subKey, subData]) => {
            if (subKey === 'nonConformance') {
              return (
                <div key={subKey} className="mt-4">
                  <h4 className="font-semibold text-gray-700">Non-Conformance</h4>
                  <p className="text-gray-600">{subData || 'N/A'}</p>
                </div>
              );
            }
            if (Array.isArray(subData)) {
              const isModuleInspection = subKey === 'ModuleInspection';
              return (
                <div key={subKey} className="mt-4">
                  <h4 className="font-semibold text-gray-700 mb-2">
                    {subKey.replace(/([A-Z])/g, ' $1').trim()}
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border rounded-lg">
                      <thead>
                        <tr className="bg-gray-100">
                          {isModuleInspection ? (
                            <>
                              <th className="px-4 py-2 text-left text-gray-700">Module Number</th>
                              <th className="px-4 py-2 text-left text-gray-700">Remarks</th>
                              <th className="px-4 py-2 text-left text-gray-700">Status</th>
                            </>
                          ) : (
                            <>
                              <th className="px-4 py-2 text-left text-gray-700">Product</th>
                              <th className="px-4 py-2 text-left text-gray-700">Frequency</th>
                              <th className="px-4 py-2 text-left text-gray-700">Observation 1</th>
                              <th className="px-4 py-2 text-left text-gray-700">Observation 2</th>
                              <th className="px-4 py-2 text-left text-gray-700">Specifications</th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {subData.map((item, index) => (
                          <tr key={index} className="border-t">
                            {isModuleInspection ? (
                              <>
                                <td className="px-4 py-2 text-gray-600">{item.moduleNumber || 'N/A'}</td>
                                <td className="px-4 py-2 text-gray-600">{item.remarks || 'N/A'}</td>
                                <td className="px-4 py-2 text-gray-600">{item.status || 'N/A'}</td>
                              </>
                            ) : (
                              <>
                                <td className="px-4 py-2 text-gray-600">{item.product || 'N/A'}</td>
                                <td className="px-4 py-2 text-gray-600">{item.frequency || 'N/A'}</td>
                                <td className="px-4 py-2 text-gray-600">{item.observation1 || 'N/A'}</td>
                                <td className="px-4 py-2 text-gray-600">{item.observation2 || 'N/A'}</td>
                                <td className="px-4 py-2 text-gray-600">{item.specifications || 'N/A'}</td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      ))}
    </div>
  );
};

export default PostLaminationView;